import AppNavbar from "../../AppNavbar/AppNavbar";

const tabs = [
  {
    title: "All Products",
    hidden: false,
    externalLink: "",
    activeValue: "all-products",
    disabled: false,
  },
  {
    title: "Installed Apps",
    hidden: false,
    externalLink: "",
    activeValue: "installed-apps",
    disabled: false,
  },
  {
    title: "My Local Apps",
    hidden: false,
    externalLink: "",
    activeValue: "local-apps",
    disabled: false,
  },
];

const GrowthCloudStoreNavbar = ({ activeTab, setActiveTab }) => {
  const handleSelect = (val) => {
    setActiveTab(val);
  };

  return (
    <div className="tw:ml-4">
      <AppNavbar
        tabs={tabs}
        activeTab={activeTab}
        onSelect={(val) => handleSelect(val)}
      />
    </div>
  );
};

export default GrowthCloudStoreNavbar;
